import Header from "./organisms/Header";
import Footer from "./organisms/Footer";
import AllRoutes from "../routes";

export default function DefaultLayout() {
  return (
    <>
      <Header />
      <AllRoutes />
      <Footer />
    </>
  );
}
